export const environment = {
  production: true,
  protocol: 'https',
  domain: 'smylo-agent-board.testing.photonic-codes.cloud',
  port: '42080',
  apiPrefix: 'api',
  keycloakUrl: 'https://kc.testing.photonic-codes.cloud',
  keycloakClient: 'smylo-client',
  syncFusionLicenseKey: 'Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH9feHVWRmddUEx+XkE=',
  notificationEmails: ['a.sunal@smylo.de', 'a.kar@smylo.de', 'y.oezden@smylo.de']
};
